/**
 * Convert API shipment notices into render-safe text. EasyPost may return a
 * carrier notice as an object rather than a string.
 */
export function formatShipmentMessage(value: unknown): string | null {
  if (typeof value === 'string') {
    const message = value.trim();
    return message || null;
  }
  if (value === null || typeof value !== 'object') return null;

  const record = value as Record<string, unknown>;
  const message = typeof record.message === 'string' ? record.message.trim() : '';
  if (!message) return null;

  const carrier = typeof record.carrier === 'string' ? record.carrier.trim() : '';
  return carrier ? `${carrier}: ${message}` : message;
}

export function normalizeShipmentMessages(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value
    .map(formatShipmentMessage)
    .filter((message): message is string => message !== null);
}
